export enum InvoicingSettingsEntryContext {
  Invoice = 'invoice',
  Quote = 'quote',
}
